import { useCallback, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { useHandleSubmitWrongPolicyNoCDV } from 'forms/hooks';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { MaxLengths } from 'constants/forms';
import contactTake from 'features/views/contactTake';
import formDescriptorFn, { CONTACT_TAKE_FORM_NAME, FIELDS } from 'features/views/contactTake/form';

export const Filter = () => {
	const dispatch = useDispatch();

	const handleReset = useCallback(() => {
		dispatch(contactTake.actions.resetCriteria());
	}, [dispatch]);

	const handleSubmit = useCallback(() => {
		dispatch(contactTake.actions.submitForm());
	}, [dispatch]);

	const handleSubmitWrongPolicyNoCDV = useHandleSubmitWrongPolicyNoCDV({ continueFn: handleSubmit });

	useEffect(
		() => () => {
			dispatch(contactTake.actions.resetCriteria());
		},
		[dispatch],
	);

	return (
		<Form name={CONTACT_TAKE_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2}>
						<Grid size={4}>
							<TextField
								size="small"
								fieldName={FIELDS.surname}
								label={getLabelMessage('contactTake:surname')}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.SURNAME,
									},
								}}
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								size="small"
								fieldName={FIELDS.firstName}
								label={getLabelMessage('contactTake:firstName')}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.NAME,
									},
								}}
							/>
						</Grid>
						<Tooltip title={getLabelMessage('tooltips:birthNumber')}>
							<Grid size={2}>
								<TextField
									size="small"
									fieldName={FIELDS.personIn}
									label={getLabelMessage('contactTake:personIn')}
									slotProps={{
										htmlInput: {
											maxLength: MaxLengths.PERSON_IN,
										},
									}}
								/>
							</Grid>
						</Tooltip>
						<Tooltip title={getLabelMessage('tooltips:policyNo')}>
							<Grid size={2}>
								<TextField
									size="small"
									fieldName={FIELDS.policyNumber}
									label={getLabelMessage('contactTake:policyNo')}
									slotProps={{
										htmlInput: {
											maxLength: MaxLengths.POLICY_NO,
										},
									}}
								/>
							</Grid>
						</Tooltip>
						<Grid size={10}>
							<TextField
								size="small"
								fieldName={FIELDS.municipality}
								label={getLabelMessage('contactTake:municipality')}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.MUNICIPALITY,
									},
								}}
							/>
						</Grid>
						<Tooltip title={getLabelMessage('tooltips:postalCode')}>
							<Grid size={2}>
								<TextField
									size="small"
									fieldName={FIELDS.zipCode}
									label={getLabelMessage('contactTake:zipCode')}
									slotProps={{
										htmlInput: {
											maxLength: MaxLengths.ZIP_CODE,
										},
									}}
								/>
							</Grid>
						</Tooltip>
						<Grid size={6} />
						<Grid size={3}>
							<Button variant="outlined" onClick={handleReset} fullWidth>
								{getLabelMessage('common:resetButton')}
							</Button>
						</Grid>
						<Grid size={3}>
							<SubmitButton
								variant="contained"
								onClick={handleSubmit}
								onClickError={handleSubmitWrongPolicyNoCDV}
								fullWidth
								text={getLabelMessage('common:searchButton')}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Form>
	);
};

export default Filter;
